import Image from './image';
import ImageRight from './image-right';

export { Image, ImageRight };
export default Image;

